import SearchBar from "./components/SearchBar"
import ApartmentGrid from "./components/ApartmentGrid"

const SearchPage = () => {
    return(
        <div className="page-content">
            <SearchBar />
            <ApartmentGrid />
        </div>
    )
}

export default SearchPage

